export const APPROVE_RATE_CHANGE_USER_IDS: readonly string[] = [
    "Ff1CPQ37aSkDOH4GksMC",
    "Qd3l20aHWmEKYoQ9ycgl",
];

export function canApproveRateChanges(userId: string | undefined): boolean {
    return !!userId && APPROVE_RATE_CHANGE_USER_IDS.includes(userId);
}
